export const recursion = (data, list, number, ids) => {
  if (number === list.length) {
    return ids;
  } else {
    const item = data.find((cItem) => {
      return cItem.TreeId === list[number];
    });
    const children = item.Children;
    ids.push({ id: item.Id, type: item.TreeNodeTypeId });
    number++;
    return recursion(children, list, number, ids);
  }
};

export const recurrence = (data) => {
  if (!data) {
    return;
  }
  if (data) {
    data.forEach((item, index, array) => {
      array[index].leftCk = false;
      if (item.Actions) {
        array[index].Actions.forEach((_, cIndex, cArray) => {
          cArray[cIndex].checked = false;
        });
      } else {
        array[index].Actions = [];
      }

      if (array[index].Children) {
        recurrence(array[index].Children);
      } else {
        array[index].Children = [];
      }
    });
  }
};

//递归
export const reproduce = (array, multipleSelection, boolen) => {
  for (let i in array) {
    var data = array[i];
    if (data.Children) {
      data.disabled = boolen;
      multipleSelection.forEach((item) => {
        if (item.ProjectID === data.ProjectID) {
          data.disabled = true;
        }
      });
      reproduce(data.Children, multipleSelection, data.disabled); //自己调用自己
    } else {
      data.disabled = boolen;
      multipleSelection.forEach((item) => {
        if (item.ProjectID === data.ProjectID) {
          data.disabled = true;
        }
      });
    }
  }
  return array;
};

//递归2

export const multipleSelection = (array, array2) => {
  for (let i in array) {
    var data = array[i];
    if (data.Children) {
      array2.push(data);
      reproduce(data.Children); //自己调用自己
    } else {
      array2.push(data);
    }
  }
  return array2;
};

export const findNavPathDetailed = (targetPath, navData) => {
  const result = [];

  function findPath(nodes, path, level = 0) {
    for (const node of nodes) {
      // 创建节点副本，避免修改原数据
      const currentNode = {
        ...node,
        level,
        isLeaf: !node.children || node.children.length === 0,
      };

      const currentPath = [...path, currentNode];

      if (node.path === targetPath) {
        result.push(...currentPath);
        return true;
      }

      if (node.children && node.children.length > 0) {
        if (findPath(node.children, currentPath, level + 1)) {
          return true;
        }
      }
    }
    return false;
  }

  findPath(navData, []);
  return result;
};
import store from "../store";
function getMenuNameByPath(menuData, path, lang) {
  console.log("lang", lang);
  // 确保 menuData 是数组，方便统一处理
  const dataArray = Array.isArray(menuData) ? menuData : [menuData];

  // 递归查找函数
  function findNode(nodes) {
    for (const node of nodes) {
      // 如果当前节点有 path 且匹配
      if (node.path === path) {
        return node;
      }

      // 如果当前节点有子节点，递归查找
      if (node.children && node.children.length > 0) {
        const found = findNode(node.children);
        if (found) {
          return found;
        }
      }
    }
    return null;
  }

  // 查找匹配的节点
  const foundNode = findNode(dataArray);

  // 如果找到节点，根据语言返回对应的名称
  if (foundNode) {
    let name = lang === "en" ? foundNode.eName : foundNode.name;
    store.commit("changeDialogName", name);
  } else {
    store.commit("changeDialogName", "");
  }
  console.log("dialogName", store.state.dialogName);
}

import lang from "../lang";
import { navigation } from "@/components/Navigation/data-zn2";

export const dialogName = () => {
  getMenuNameByPath(
    navigation,
    sessionStorage.getItem("lastRoute"),
    localStorage.getItem("lang") || lang.locale,
  );
};
